import React, { Component } from 'react';
import { Row, Col } from 'react-flexbox-grid';
import _ from 'lodash';
import { translate } from 'react-i18next';

class OverallStatistics extends Component {
    constructor(props) {
        super(props);
        this.state = { statistics: props.statistics, prefix: props.prefix || '' };
    }

    async componentWillReceiveProps(nextProps) {
        this.setState({ statistics: nextProps.statistics });
    }

    render() {
        const revenue = this.state.statistics;
        const month = _.get(revenue, `month`);
        const impression = _.get(revenue, `impression.goal` || 0);
        const trafficCtr = _.get(revenue, `trafficCtr.goal` || 0);
        const optinCtr = _.get(revenue, `optinCtr.goal` || 0);
        const closerateCtr = _.get(revenue, `closerateCtr.goal` || 0);
        const {t} = this.props;
        return (
            <Row>
	    	<Col md={12} className="stat-header">
	    		{month ? month.format('MMMM YYYY') : ''}
	    	</Col>
	    	<Col md={12}>
		    	<div className="stat-box stat-feedbacks">
		    		<div className="stat-value">{Number(impression).toFixed(0)}</div>
		    		<div className="stat-description">{t('dashboard.statistics.impressions')}</div>
		    	</div>
		    	<div className="stat-box stat-profit">
		    		<div className="stat-value">{Number(trafficCtr).toFixed(2)} %</div>
		    		<div className="stat-description">{t('dashboard.statistics.traffic')}</div>
		    	</div>
		    	<div className="stat-box stat-orders">
		    		<div className="stat-value">{Number(optinCtr).toFixed(2)} %</div>
		    		<div className="stat-description">{t('dashboard.statistics.optin')}</div>
		    	</div>
		    	<div className="stat-box stat-popularity">
		    		<div className="stat-value">{Number(closerateCtr).toFixed(2)} %</div>
		    		<div className="stat-description">{t('dashboard.statistics.closeRate')}</div>
		    	</div>
		    	<div className="stat-box stat-revenue">
		    		<div className="stat-value">{this.state.prefix} {Number((revenue) ? revenue.getTotalRevenues('goal') : 0).toFixed(2)}</div>
		    		<div className="stat-description">{t('dashboard.statistics.revenue')}</div>
		    	</div>
	    	</Col>
    	</Row>
        );
    }
}

export default translate('translations')(OverallStatistics);


// WEBPACK FOOTER //
// ./src/components/dashboard/OverallStatistics.js